module.exports = __webpack_public_path__ + "img/3.85c808c1.png";